import { soadNoCertPart1DataSchema } from "../../schemas/soad/soad-nocert.js";
const getSecondOpinionRequestedText = (secondOpinionRequested) => {
    switch (secondOpinionRequested) {
        case "ect":
            return "Electroconvulsive Therapy (ECT)";
        case "medication":
            return "Medication";
        case "both":
            return "Medication & Electroconvulsive Therapy (ECT)";
        default:
            return "Please complete the Assessment Details section";
    }
};
export const soadNoCertPart1Template = {
    signing: {
        userOrTeamRequirement: {
            accreditation: [],
            teamType: ["soad"],
        },
    },
    formBuilderFields: [
        {
            type: "practitioner",
            field: "practitioner",
            label: "SOAD name and address",
            hideWarningBanners: true,
        },
        {
            type: "label",
            showStaticLabel: true,
            label: ["What was the request for?"],
        },
        {
            type: "readonly",
            textFn: (_data, context) => {
                const part3 = context.previousPartsFormData.find((s) => s.section === "currentAndProposedTreatment")?.data;
                const secondOpinionRequested = part3?.secondOpinionRequested;
                return [getSecondOpinionRequestedText(secondOpinionRequested)];
            },
            afterLabel: "Taken from the ‘Current and Proposed Treatment’ section which you completed earlier.",
        },
        {
            type: "textbox",
            field: "reasons",
            label: "Reasons for not issuing a certificate",
            rows: "5",
            copyFrom: {
                valueFn: (_data, context) => {
                    const part5 = context.previousPartsFormData.find((s) => s.section === "soadAuthorisation")?.data;
                    return [part5?.notApprovedReason].filter(Boolean).join("\n\n");
                },
                label: "Copy from SRF Reasons",
            },
            afterLabel: "Briefly explain why you chose not to issue a certificate. This will be shared with both the CQC and the provider.",
        },
    ],
    dataSchema: soadNoCertPart1DataSchema,
};
export const soadNoCertV1Base = {
    id: "mha-soad-nocert",
    category: "soad",
    version: "1.0",
    status: "active",
    formName: "No Certificate",
    section: "",
    parts: [soadNoCertPart1Template],
    description: "",
    extractGenericData: (_data) => ({}),
};
//# sourceMappingURL=soad-nocert.js.map